// import * as requestLib from '../requestLib'

let baseUrl = window.location.origin;

const constants = {
    ERROR_CODE : {
        FRONT_END_ERROR : 'FRONT_END_ERROR'
    },
    URL: {
        LOGIN : baseUrl,
        LIST : baseUrl + "/list",
        DASHBOARD : baseUrl + "/square",
        SETTING : baseUrl + "/setting",
        USER_DASHBOARD : baseUrl + "/userDashboard",
        HISTORY : baseUrl + "/history",
        CAMERA : baseUrl + "/camera",
        DEMOLIST: baseUrl + "/demolist",
        DEMODASHBOARD: baseUrl + "/demosquare",
        // HISTORY: baseUrl + "/history",
    },

}


export default constants;